
define('eteration/widgets/common/ui-login-otp',['knockout'], function(ko){
	ko.components.register('login-otp', {
	    viewModel: {
	    	require: "eteration/widgets/common/components/login-otp/login-otp-viewmodel"
		},
	    template: {
	    	require: "text!eteration/widgets/common/components/login-otp/login-otp.html"
		}
	});
});